import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { ExtractionQuestion } from '../domain/extraction-question.model';

/**
 * Port interface defining outward persistence rules for the questionnaire schema.
 * All driving adapters (UI components) must consume this port contract directly,
 * rather than hard-wiring to Angular's HttpClient or REST services.
 */
export interface QuestionnairePort {
  /**
   * Fetches all extraction questions for a given project.
   */
  getQuestions(projectId: string | number): Observable<ExtractionQuestion[]>;

  /**
   * Saves or updates the entire ordered list of extraction questions for a project.
   */
  saveQuestions(
    projectId: string | number,
    questions: ExtractionQuestion[],
  ): Observable<ExtractionQuestion[]>;
}

/**
 * Injection Token to bind concrete adapters at the composition root.
 */
export const QUESTIONNAIRE_PORT = new InjectionToken<QuestionnairePort>('QuestionnairePort');
